import { decode } from "html-entities";

const LEGACY_ENTITY_ALIASES: Record<string, string> = {
	"&gte;": "&ge;",
	"&lte;": "&le;",
};

export const decodeHtmlEntities = (value: string): string => {
	let normalized = value;
	for (const [alias, entity] of Object.entries(LEGACY_ENTITY_ALIASES)) {
		normalized = normalized.replaceAll(alias, entity);
	}
	return decode(normalized);
};
